import "./Card_module.css";
const Card_module = {
    card: "card__7e30041e33216702",
    subtitle: "subtitle__7e30041e33216702",
    clickable: "clickable__7e30041e33216702",
    body: "body__7e30041e33216702",
    small: "small__7e30041e33216702",
    content: "content__7e30041e33216702"
};
export { Card_module as default };
